import {mapState,mapGetters,mapMutations} from "vuex"
import preset from "@/store/preset";
export default {
    computed:{
        ...mapState(['process','preset']),
        ...mapGetters('preset',['client_token']),
        ...mapGetters('process',['isCollapsed']),
        ...mapGetters('user',['user']),
        en(){
            return this.$english();
        },
        english(){
            return this.$english();
        },
        mobile() {
            return this.$isMobile();
        },
        loading(){
            return this.process.loading;
        },
        rules() {
            let rules = {};
            for (let x in this.fields) {
                const field = this.fields[x];
                if (field.validation) {
                    rules[x] = [];
                    field.validation.forEach(item => {
                        const trigger = ['text', 'textarea', 'number'].includes(item.type) ? 'blur' : 'change';
                        if (item === 'required') {
                            rules[x].push({
                                required: true,
                                message: this.english ? ((field.title_en || field.title) + " is required!") : ('请输入' + field.title),
                                trigger: trigger
                            });
                        }
                        if (item.indexOf('min:') === 0 || item.indexOf('max:') === 0) {
                            let cmd = item.split(':');
                            if (cmd.length > 1) {
                                let v = {
                                    message: (cmd[0] === 'min' ? ('最小') : ('最大')) + cmd[1] + ('个字'),
                                    trigger: 'blur'
                                };
                                v[cmd[0]] = parseInt(cmd[1]);
                                rules[x].push(v);
                            }
                        }
                        if (item.indexOf('email') === 0) {
                            rules[x].push({
                                type: 'email',
                                message: ('请输入正确的邮箱格式'),
                                trigger: trigger
                            });
                        }
                    });
                }
            }
            return rules;
        },
    },
    methods:{
        setLanguage() {
            this.$setLocale()
        },
        ...mapMutations('user', ['clear','setUserInfo']),
        ...mapMutations('process', ['setCollapsed','setFilter']),
        setLocale() {
            this.setLanguage(!this.english);
        },
        setWindowTitle(){
            window.title = preset.app?preset.app.title:"";
        }
    },
}
